"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var tasks;
        (function (tasks) {
            var activities;
            (function (activities) {
                class InitArgs {
                    constructor() {
                        this.activityTypes = [];
                        this.formsList = [];
                        this.docsList = [];
                        this.isTaskRecurringContext = false;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                }
                activities.init = init;
                function addEvents() {
                    $('form#uploadForm').on('submit', function () {
                        let counter = 0;
                        const value = $(this).val();
                        $('input[name=fileName]').each(function () {
                            const input = `<input name="Task.Files[${counter}].Name" id="Task_Files_${counter}__Name type="hidden" value="${value}"/> `;
                            $('form#uploadForm').append(input);
                            counter++;
                        });
                        return true;
                    });
                    $('#attachfiles').on('click', function (e) {
                        e.preventDefault();
                        const idx = new Date().getTime();
                        const items = '<tr><td class="typeCell"><div>' +
                            `<input type="hidden" name="Task.Files.Index" value="${idx}" />` +
                            `<input type="file" name="docfile" id="docfile${idx}" />` +
                            `<span class="field-validation-valid" data-valmsg-for="Task.Files[${idx}].Name" data-valmsg-replace="true" ></span>` +
                            '</div></td>' +
                            '<td></td><td class=""></td>' +
                            `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow('delete_file_button')}` +
                            '</td></tr> ';
                        $('#attachmentItems tbody').append(items);
                    });
                    $('.addValue').on('click', function (e) {
                        e.preventDefault();
                        const $items = $('#actItems tbody');
                        const idx = $items.children().length;
                        let activitytypes = appn.emptyString;
                        for (let i = 0; i < _initArgs.activityTypes.length; i++)
                            activitytypes += `<option value="${_initArgs.activityTypes[i].value}">${_initArgs.activityTypes[i].text}</option>`;
                        const activityitems = '<tr><td class="typeCell">' +
                            `<select class="activityType form-control form-control-sm" name="Task.Activities[${idx}].ActivityType" id="Task_Activities_${idx}__ActivityType" data-val-required="${T("The {0} field is required.", "Activity Type")}" data-val="true">` +
                            `<option value="">${appn.strings.choose}</option>` +
                            `${activitytypes}</select></td>` +
                            `<td class="detailsCell form-flex" id="Cell_${idx}"></td>` +
                            `<td class="td-optional">${appn.elementBuilder.buildCheckbox('', 'actIsOptional', `Task_Activities_${idx}__IsOptional`, appn.elementBuilder.ICheckColor.primary, `Task.Activities[${idx}].IsOptional`, true)}</td >` +
                            `${(!_initArgs.isTaskRecurringContext ? '<td></td>' : appn.emptyString)}` +
                            '<td class="activity-row-options">' +
                            '<div class="btn-group" role="group">' +
                            `${appn.elementBuilder.buildBtnMoveRow(true)}` +
                            `${appn.elementBuilder.buildBtnMoveRow(false)}` +
                            appn.elementBuilder.buildBtnRemoveRow('delete_button') +
                            '</div>' +
                            '</td></tr>';
                        $('#actItems tbody').append(activityitems);
                        appn.select.init({
                            selector: `select#Task_Activities_${idx}__ActivityType`
                        });
                        appn.ui.checkboxForceOnChanged('.actIsOptional');
                    });
                    $(document).on('click', '.down_button', function () {
                        const rowToMove = $(this).parents('#actItems tbody tr:first');
                        const next = rowToMove.next('#actItems tbody tr');
                        if (next.length === 1) {
                            next.after(rowToMove);
                            renameRows();
                        }
                    });
                    $(document).on('click', '.up_button', function () {
                        const rowToMove = $(this).parents('#actItems tbody tr:first');
                        const prev = rowToMove.prev('#actItems tbody tr');
                        if (prev.length === 1) {
                            prev.before(rowToMove);
                            renameRows();
                        }
                    });
                    $(document).on('click', '.delete_button', function () {
                        $(this).parents('tr').remove();
                        renameRows();
                    });
                    $(document).on('click', '.delete_file_button', function () {
                        $(this).parents('tr').remove();
                    });
                    $(document).on('change', '.activityType', function () {
                        const idname = $(this).attr('id');
                        const value = $(this).val();
                        if (idname) {
                            const idx = idname.replace('Task_Activities_', appn.emptyString).replace('__ActivityType', appn.emptyString);
                            setDetails(value, idx);
                        }
                    });
                }
                function renameRows() {
                    let idx = 0;
                    $('#actItems tbody tr').each(function (index, row) {
                        $(this).find('.detailsCell')
                            .attr('id', `Cell_${idx}`);
                        const activityType = $(this).find('.typeCell select');
                        activityType
                            .attr('name', `Task.Activities[${idx}].ActivityType`)
                            .attr('id', `Task_Activities_${idx}__ActivityType`);
                        if (activityType.val() === 'FillOutForm' || activityType.val() === 'ReadDoc') {
                            $(this).find('.detailsCell select')
                                .attr('name', `Task.Activities[${idx}].RelatedId`)
                                .attr('id', `Task_Activities_${idx}__RelatedId`);
                            $(this).find('.detailsCell input')
                                .attr('name', `Task.Activities[${idx}].Name`)
                                .attr('id', `Task_Activities_${idx}__Name`);
                        }
                        else if (activityType.val() === 'Instruction') {
                            $(this).find('.detailsCell textarea')
                                .attr('name', `Task.Activities[${idx}].Details`)
                                .attr('id', `Task_Activities_${idx}__Details`);
                            $(this).find('.hidden-activity-details')
                                .attr('name', `Task.Activities[${idx}].Details`)
                                .attr('id', `Task_Activities_${idx}__Details`);
                        }
                        $(this).find('.td-optional input')
                            .attr('name', `Task.Activities[${idx}].IsOptional`)
                            .attr('id', `Task_Activities_${idx}__IsOptional`);
                        $(this).find('.hidden-activity-id')
                            .attr('name', `Task.Activities[${idx}].Id`)
                            .attr('id', `Task_Activities_${idx}__Id`);
                        $(this).find('.hidden-activity-keyId')
                            .attr('name', `Task.Activities[${idx}].KeyId`)
                            .attr('id', `Task_Activities_${idx}__KeyId`);
                        $(this).find('.hidden-activity-completeTicks')
                            .attr('name', `Task.Activities[${idx}].CompleteTicks`)
                            .attr('id', `Task_Activities_${idx}__CompleteTicks`);
                        $(this).find('.hidden-activity-type')
                            .attr('name', `Task.Activities[${idx}].ActivityType`)
                            .attr('id', `Task_Activities_${idx}__ActivityType`);
                        $(this).find('.hidden-activity-relatedId')
                            .attr('name', `Task.Activities[${idx}].RelatedId`)
                            .attr('id', `Task_Activities_${idx}__RelatedId`);
                        idx++;
                    });
                }
                function setDetails(activityType, idx) {
                    let html = appn.emptyString;
                    let optionlist = appn.emptyString;
                    let initSelect = false;
                    switch (activityType) {
                        case 'FillOutForm': {
                            const choose = appn.strings.choose;
                            for (let i = 0; i < _initArgs.formsList.length; i++)
                                optionlist += `<option value="${_initArgs.formsList[i].value}">${_initArgs.formsList[i].text}</option>`;
                            html = `<select class="form-control form-control-sm" name="Task.Activities[${idx}].RelatedId" id="Task_Activities_${idx}__RelatedId" data-val-required="${T("The Activity Details field is required.")}" data-val="true"><option value="">${choose}</option>${optionlist}</select>` +
                                `<input class="form-control form-control-sm ml-2" id="Task_Activities_${idx}__Name" name="Task.Activities[${idx}].Name" placeholder="${T("Optional activity name...")}" type="text"/>`;
                            initSelect = true;
                            break;
                        }
                        case 'ReadDoc': {
                            const choose = appn.strings.choose;
                            for (let i = 0; i < _initArgs.docsList.length; i++)
                                optionlist += `<option value="${_initArgs.docsList[i].value}">${_initArgs.docsList[i].text}</option>`;
                            html = `<select class="form-control form-control-sm" name="Task.Activities[${idx}].RelatedId" id="Task_Activities_${idx}__RelatedId" data-val-required="${T("The Activity Details field is required.")}" data-val="true"><option value="">${choose}</option>${optionlist}</select>` +
                                `<input class="form-control form-control-sm ml-2" id="Task_Activities_${idx}__Name" name="Task.Activities[${idx}].Name" placeholder="${T("Optional activity name...")}" type="text"/>`;
                            initSelect = true;
                            break;
                        }
                        case 'Instruction': {
                            html = `<textarea cols="20" rows="1" class="form-control form-control-sm" name="Task.Activities[${idx}].Details" id="Task_Activities_${idx}__Details" data-val-required="${T("The Activity Details field is required.")}" data-val-length-max="500" data-val-length="${T("The field must be a string with a maximum length of 500.")}" ></textarea>`;
                            break;
                        }
                    }
                    const detailsCell = $(`#Cell_${idx}`);
                    detailsCell.html(html);
                    if (initSelect)
                        appn.select.init({
                            selector: `select#Task_Activities_${idx}__RelatedId`
                        });
                }
            })(activities = tasks.activities || (tasks.activities = {}));
        })(tasks = views.tasks || (views.tasks = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
